const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function sessionId() {
  let s = localStorage.getItem("milla_sid");
  if (!s) {
    s = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random()}`;
    localStorage.setItem("milla_sid", s);
  }
  return s;
}

// Fire-and-forget funnel event tracking
export function track(event) {
  try {
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId(), event }),
      keepalive: true,
    });
  } catch (e) {
    /* never block UX on analytics */
  }
}
